import { PRIMARY_BUCKET } from '@/src/homepage/constants';
import { TABS_CONFIG } from '@/src/homepage/constants/tabConfig';
import { BucketProps } from '../containers/BucketContainer/BucketContainer';
import { ONLINE_EVENTS } from '../containers/BucketContainer/BucketContainer.constants';
import { isMessageDescriptor } from '@/src/homepage/types/intl';

function toDisplayText(descriptor: unknown): string {
    if (!isMessageDescriptor(descriptor)) return '';
    const defaultMsg =
        typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
    return defaultMsg || descriptor.id || '';
}

export function formatBucketLabelFromKey({
    bucketKey,
    tabKey,
    name,
    currentPlace,
}: Pick<BucketProps, 'bucketKey' | 'tabKey' | 'name' | 'currentPlace'>) {
    if (currentPlace === ONLINE_EVENTS && bucketKey === PRIMARY_BUCKET) {
        return ONLINE_EVENTS;
    }

    const bucketLabel =
        (typeof name === 'string' ? name : toDisplayText(name)) ||
        (tabKey && toDisplayText(TABS_CONFIG[tabKey]?.name));

    if (!bucketLabel) return undefined;

    return bucketKey && bucketKey !== PRIMARY_BUCKET
        ? `${bucketLabel} in ${currentPlace}`
        : bucketLabel;
}
